"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtensionUI = exports.openPreview = exports.getContentPath = void 0;
const React = require("react");
const react_1 = require("react");
const styled_1 = require("@emotion/styled");
const Gatsby_1 = require("./Gatsby");
const normalize = part => part.replace(/\/$/, ``);
function getContentPath({ contentSlug, previewUrl, authToken }) {
    return __awaiter(this, void 0, void 0, function* () {
        const entryUrl = contentSlug && contentSlug.startsWith(`/`)
            ? contentSlug.slice(1)
            : contentSlug;
        const normalizedPreviewUrl = normalize(previewUrl);
        const pathQuery = `query getQualifiedSlug($entryUrl:String) { sitePage( path:{ ${entryUrl ? `regex` : `eq`}:$entryUrl } ) { path } }`;
        const pathVariables = {
            entryUrl: `/`,
        };
        if (entryUrl) {
            /**
             * The first "/" is important — it ensures that we look for an exact match for the slug
             *
             * E.g. if we have a "good-day" slug, we want to find pages with "/good-day" slug
             * and not a "/hello-world-what-a-good-day"
             */
            const slugRegex = `/${entryUrl}/?$`;
            pathVariables.entryUrl = `/${slugRegex}/`;
        }
        try {
            const res = yield fetch(`${normalizedPreviewUrl}/___graphql`, {
                method: `POST`,
                headers: {
                    "Content-Type": `application/json`,
                    Authorization: authToken,
                },
                body: JSON.stringify({
                    query: pathQuery,
                    variables: pathVariables,
                }),
            });
            const { data } = yield res.json();
            const path = data ? data.sitePage.path : ``;
            return `${normalizedPreviewUrl}${path}`;
        }
        catch (e) {
            return `${normalizedPreviewUrl}/${entryUrl}`;
        }
    });
}
exports.getContentPath = getContentPath;
function openPreview({ contentSlug, previewUrl, authToken }) {
    return __awaiter(this, void 0, void 0, function* () {
        const path = yield getContentPath({
            contentSlug,
            previewUrl,
            authToken,
        });
        return window.open(path, `GATSBY_TAB`);
    });
}
exports.openPreview = openPreview;
const Button = styled_1.default(`button`) `
  border: 0;
  border-radius: 4px;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
  width: 100%;
  color: white;
  background-color: #663399;
  height: 2.5rem;

  ${props => props.disabled
    ? `
        background-color: grey;
      `
    : `
        &:hover {
          background-color: #542c85;
          cursor: pointer;
        }
  `}
`;
const Text = styled_1.default(`p`) `
  color: #7f7c82;
  font-family: inherit;
  font-size: 16px;
  margin-bottom: 0;
  margin-right: 5%;
`;
const PoweredBy = styled_1.default(`div`) `
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  margin-right: 5%;
`;
function ExtensionUI({ contentSlug, previewUrl, authToken, onOpenPreviewButtonClick, children, disablePreviewOpen = false, disabled = false, }) {
    return (React.createElement("div", null,
        previewUrl ? (React.createElement(react_1.Fragment, null,
            React.createElement(Button, { disabled: disabled, className: "preview-button", type: "button", onClick: () => __awaiter(this, void 0, void 0, function* () {
                    let previewWindow = null;
                    /**
                     * This can be disabled when the app using this component wants to control opening the preview url using the onOpenPreviewButtonClick prop instead. Content Sync does this for Contentful for example.
                     */
                    if (!disablePreviewOpen) {
                        previewWindow = contentSlug
                            ? openPreview({ contentSlug, previewUrl, authToken })
                            : window.open(previewUrl);
                    }
                    /**
                     * The consuming CMS app/addon sometimes needs a reference to the opened preview window.
                     * For instance, CMS apps can change what preview a user is pointed at in the case that
                     * a newer preview build is available
                     */
                    onOpenPreviewButtonClick === null || onOpenPreviewButtonClick === void 0 ? void 0 : onOpenPreviewButtonClick({ previewWindow });
                }) }, "Open Preview"),
            children)) : (React.createElement(Text, null, "Missing required Gatsby Cloud Preview url. Please check your configuration.")),
        React.createElement(PoweredBy, { className: "powered-by" },
            React.createElement(Text, null, "Powered by:"),
            React.createElement(Gatsby_1.default, null))));
}
exports.ExtensionUI = ExtensionUI;
//# sourceMappingURL=index.js.map